export function Field({ label, children, hint }) {
  return (
    <label className="block mb-4">
      <span className="block text-xs font-semibold uppercase tracking-wider text-sunset-muted mb-2">{label}</span>
      {children}
      {hint && <span className="block text-xs text-sunset-muted mt-1">{hint}</span>}
    </label>
  );
}

export function Input(props) {
  return <input {...props} className={`w-full bg-white border border-sunset-border px-3.5 py-2.5 text-sm focus:outline-none focus:border-sunset-accent ${props.className || ""}`} />;
}

export function Textarea(props) {
  return <textarea {...props} className={`w-full bg-white border border-sunset-border px-3.5 py-2.5 text-sm focus:outline-none focus:border-sunset-accent resize-y ${props.className || ""}`} />;
}

export function Select({ children, ...props }) {
  return <select {...props} className={`w-full bg-white border border-sunset-border px-3.5 py-2.5 text-sm focus:outline-none focus:border-sunset-accent ${props.className || ""}`}>{children}</select>;
}

export function Btn({ children, variant = "primary", ...props }) {
  const styles = {
    primary: "bg-sunset-ink text-white hover:bg-sunset-accent",
    accent: "bg-sunset-accent text-white hover:bg-sunset-ink",
    ghost: "bg-transparent text-sunset-ink border border-sunset-border hover:border-sunset-ink",
    danger: "bg-red-600 text-white hover:bg-red-700",
  };
  return (
    <button {...props} className={`inline-flex items-center justify-center gap-2 text-xs font-semibold uppercase tracking-wider px-5 py-2.5 transition-colors disabled:opacity-50 ${styles[variant]} ${props.className || ""}`}>
      {children}
    </button>
  );
}

export function Toggle({ checked, onChange, label }) {
  return (
    <button type="button" onClick={() => onChange(!checked)} className="flex items-center gap-3">
      <span className={`w-11 h-6 rounded-full transition-colors relative ${checked ? "bg-sunset-accent" : "bg-sunset-border"}`}>
        <span className={`absolute top-0.5 w-5 h-5 bg-white rounded-full transition-all ${checked ? "left-[22px]" : "left-0.5"}`} />
      </span>
      {label && <span className="text-sm">{label}</span>}
    </button>
  );
}

export function Modal({ open, onClose, title, children, wide }) {
  if (!open) return null;
  return (
    <div className="fixed inset-0 z-[300] flex items-start justify-center p-4 md:p-8 bg-black/50 overflow-y-auto" onClick={onClose}>
      <div className={`bg-sunset-bg w-full ${wide ? "max-w-3xl" : "max-w-lg"} my-8 shadow-2xl`} onClick={(e) => e.stopPropagation()}>
        <div className="flex items-center justify-between px-6 py-4 border-b border-sunset-border bg-white">
          <h3 className="font-serif text-2xl">{title}</h3>
          <button onClick={onClose} className="text-sunset-muted hover:text-sunset-ink text-2xl leading-none">×</button>
        </div>
        <div className="p-6">{children}</div>
      </div>
    </div>
  );
}
